import { apiV2Instance } from '../../common/lib/api-v2.client';

export function bindQuickLinksHold(
  token: string,
  holdKey: string,
): Promise<{ awarded?: boolean; bound?: boolean }> {
  return apiV2Instance
    .post('/api/lifetime-access-credits/quick-links-offer/bind', { token, holdKey })
    .then((response) => response.data);
}
